import { createFileRoute, redirect } from '@tanstack/react-router'
import { LeaveRequestDetail } from '@/features/hr-leave/leave-request-detail'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one request's detail — minutes §3's "which specific days were
 * taken" (plans/09-hr-05 Task 6).
 *
 * Sits under `/hr/leave/{id}` rather than the plan's `/hr/time-off/{id}` for the
 * same reason as its parent: slice 0's module rail points at `/hr/leave` and no
 * slice 1–7 may edit it.
 */
export const Route = createFileRoute('/_authenticated/hr/leave/$requestId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'leave.view')) {
      // A notification link reaches here without the grant: own requests live on the phone.
      throw redirect({ to: '/get-the-app' })
    }
  },
  component: LeaveRequestRoute,
})

function LeaveRequestRoute() {
  const { requestId } = Route.useParams()

  return <LeaveRequestDetail requestId={requestId} />
}
